import axios, { AxiosInstance } from 'axios'

import { bacenClient } from './clients/bacenClient'
import { billsClient } from './clients/billsClient'
import { cepClient } from './clients/cepClient'
import { contactConfirmation } from './clients/contactConfirmation'
import { partnerRegisterClient } from './clients/partnerRegisterClient'
import { registerValidationClient } from './clients/registerValidationClient'
import { subdelegatedClient } from './clients/subdelegatedClient'
import { RetryConfig } from './retryConfig'

const axiosConfig: RetryConfig = {
  timeout: 30000,
  retry: 2,
  retryDelay: 1000
}

const customAxiosApi: AxiosInstance = axios.create(axiosConfig)

customAxiosApi.interceptors.response.use(
  response => response,
  error => {
    const config: RetryConfig | undefined = error.config
    const shouldRetry = config?.retryCondition ? config.retryCondition(error) : true

    if (!config || !config.retry || config.method?.toLowerCase() !== 'get' || !shouldRetry) {
      return Promise.reject(error)
    }
    config.retry -= 1
    const delayRetryRequest = new Promise<void>(resolve => {
      setTimeout(() => {
        resolve()
      }, config.retryDelay || 1000)
    })
    return delayRetryRequest.then(() => customAxiosApi(config))
  }
)

const _billsClient = billsClient(customAxiosApi)
const _partnerRegisterClient = new partnerRegisterClient(customAxiosApi)
const _bacenClient = bacenClient(customAxiosApi)
const _contactConfirmation = contactConfirmation(customAxiosApi)
const _registerValidationClient = registerValidationClient(customAxiosApi)
const _subdelegatedClient = subdelegatedClient(customAxiosApi)
const _cepClient = cepClient(customAxiosApi)

export {
  _billsClient as billsClient,
  _partnerRegisterClient as partnerRegisterClient,
  _bacenClient as bacenClient,
  _contactConfirmation as contactConfirmation,
  _registerValidationClient as registerValidationClient,
  _subdelegatedClient as subdelegatedClient,
  _cepClient as cepClient
}
